import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import HomePage from '@/pages/home/page';
import MarketplacePage from '@/pages/marketplace/page';
import ProductDetailPage from '@/pages/marketplace/ProductDetailPage';
import LoginPage from '@/pages/auth/login';
import RegisterPage from '@/pages/auth/register';
import ForgotPasswordPage from '@/pages/auth/forgot-password';
import ResetPasswordPage from '@/pages/auth/reset-password';
import VerifyEmailPage from '@/pages/auth/verify-email';
import DashboardPage from '@/pages/dashboard/page';
import ProductsPage from '@/pages/products/page';
import OrdersPage from '@/pages/orders/page';
import PaymentsPage from '@/pages/payments/page';
import SubscriptionsPage from '@/pages/subscriptions/page';
import AdminPage from '@/pages/admin/page';
import DeveloperPage from '@/pages/developer/page';
import AccountPage from '@/pages/account/page';
import SupportPage from '@/pages/support/page';
import PrivacyPolicyPage from '@/pages/legal/PrivacyPolicyPage';
import TermsPage from '@/pages/legal/TermsPage';
import TwoFactorVerifyPage from '@/pages/auth/two-factor-verify';
import ProtectedRoute from '@/components/feature/ProtectedRoute';
import AdminRoute from '@/components/feature/AdminRoute';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/marketplace', element: <MarketplacePage /> },
  { path: '/marketplace/:productSlug', element: <ProductDetailPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/verify-email', element: <VerifyEmailPage /> },
  { path: '/2fa/verify', element: <TwoFactorVerifyPage /> },
  { path: '/dashboard', element: <ProtectedRoute element={<DashboardPage />} /> },
  { path: '/products', element: <ProtectedRoute element={<ProductsPage />} /> },
  { path: '/orders', element: <ProtectedRoute element={<OrdersPage />} /> },
  { path: '/payments', element: <ProtectedRoute element={<PaymentsPage />} /> },
  { path: '/subscriptions', element: <ProtectedRoute element={<SubscriptionsPage />} /> },
  { path: '/developer', element: <ProtectedRoute element={<DeveloperPage />} /> },
  { path: '/account', element: <ProtectedRoute element={<AccountPage />} /> },
  { path: '/support', element: <ProtectedRoute element={<SupportPage />} /> },
  { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
  { path: '/terms', element: <TermsPage /> },
  // Admin routes — each tab has its own URL for deep-linking & refresh persistence
  { path: '/admin', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/analytics', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/products', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/users', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/subscriptions', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/orders', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/payments', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/tickets', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/settings', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/smtp', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/site-settings', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/logs', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/notifications', element: <AdminRoute element={<AdminPage />} /> },
  { path: '/admin/changelog', element: <AdminRoute element={<AdminPage />} /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
